import type { NeonSearchOption } from '@art-basel/artbasel-lib-neon';
import { countries, PaymentSystem, type SupportedCurrency } from '@art-basel/artbasel-lib-platform';

export const sortByLabel = (a: { label: string }, b: { label: string }) =>
  a.label < b.label ? -1 : a.label > b.label ? 1 : 0;

// values based on ISO 4217 standard
export const salesCurrencyCodes = ['CHF', 'EUR', 'GBP', 'USD'];

export const getSalesCurrencies = (): Array<NeonSearchOption> => {
  const result = salesCurrencyCodes.map((value) => ({ label: value, key: value }));
  result.sort(sortByLabel);
  return result;
};

export const getPayoutCurrencyOptions = (
  currencies: SupportedCurrency[],
): Array<NeonSearchOption & SupportedCurrency> =>
  currencies.map((value) => ({
    ...value,
    label: value.currency,
    key: `${value.currency}-${value.paymentSystem}`,
    description: countries
      .filter((country) => value.supportedCountries.includes(country.key))
      .map((country) => country.label)
      .join(', '),
  }));

export const getPaymentSystemForCurrency = (
  currency: string,
  currencies: SupportedCurrency[],
): PaymentSystem | undefined => {
  return currencies.find((c) => c.currency === currency)?.paymentSystem;
};

export const isIbanCurrency = (currency: string, currencies: SupportedCurrency[]) => {
  const paymentSystemForCurrency = getPaymentSystemForCurrency(currency, currencies);
  if (!paymentSystemForCurrency) {
    return false;
  }
  return isSEPACH(paymentSystemForCurrency) || isSEPACurrency(paymentSystemForCurrency);
};
export const isSEPACurrency = (paymentSystem: PaymentSystem) => paymentSystem === PaymentSystem.SEPA;
export const isSEPACH = (paymentSystem: PaymentSystem) => paymentSystem === PaymentSystem.SEPACH;
